import { createContext, useContext } from 'react';
import type { PropsWithChildren } from 'react';
import type { Question } from '@/models/Question';
import type { SupportedLanguage } from '@/models/TranslatableField';
import type { QuestionViewMode } from '../types';

export type QuestionViewContextValue = {
  question: Question;
  mode: QuestionViewMode;
  language: SupportedLanguage;
  isReadOnly: boolean;
};

const QuestionViewContext = createContext<QuestionViewContextValue | null>(null);

type QuestionViewProviderProps = PropsWithChildren<{
  question: Question;
  mode: QuestionViewMode;
  language: SupportedLanguage;
}>;

export function QuestionViewProvider({
  children,
  question,
  mode,
  language,
}: QuestionViewProviderProps) {
  const isReadOnly = mode !== 'answering';

  return (
    <QuestionViewContext.Provider value={{ question, mode, language, isReadOnly }}>
      {children}
    </QuestionViewContext.Provider>
  );
}

export function useQuestionView() {
  const context = useContext(QuestionViewContext);
  if (!context) {
    throw new Error('useQuestionView must be used within a QuestionViewProvider');
  }
  return context;
}
